import { useEffect } from "react";

let lockCount = 0;
let previousOverflow: string | null = null;

function lock() {
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

function unlock() {
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = previousOverflow ?? "";
    previousOverflow = null;
  }
}

/**
 * Locks page scroll while `active` is true.
 *
 * - For components that only mount while open (standalone modal components),
 *   call `useBodyScrollLock()` with no args — it locks for the component's lifetime.
 * - For modals rendered conditionally inside an always-mounted parent, pass the
 *   open boolean explicitly: `useBodyScrollLock(isOpen)`. The lock/unlock is kept
 *   in sync whenever `active` toggles between renders.
 */
export function useBodyScrollLock(active: boolean = true) {
  useEffect(() => {
    if (!active) return;
    lock();
    return unlock;
  }, [active]);
}
